import { render, staticRenderFns } from "./UploadImages.vue?vue&type=template&id=60324ec1&scoped=true&"
import script from "./UploadImages.vue?vue&type=script&lang=js&"
export * from "./UploadImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60324ec1",
  null
  
)

export default component.exports